import Vue from 'vue'
import { getProgramPlans } from './forms/fields'
import { ProgramPlan, Lesson, Action } from './structs/structs'
import { APIError } from './helpers'

const structs = new Map(
  [
    ['program-lesson', Lesson],
    ['program-action', Action]
  ]
)

// REF: https://css-tricks.com/building-renderless-vue-components/
export const ProgramPlansUpdater = Vue.component(
  'ProgramPlansUpdater',
  {
    props: {
      itemId: {
        type: Number,
        required: false,
        default () { return null }
      },
      itemType: {
        type: String,
        required: true
      },
      existingItem: {
        validator (value) {
          return value === null || value.className === 'Action' || value.className === 'Lesson'
        },
        required: false,
        default () { return new (structs.get(`program-${this.itemType}`))() }
      },
      validatedItem: {
        validator (value) {
          return value === null || value.className === 'Action' || value.className === 'Lesson'
        },
        required: true
      }
    },
    computed: {
      affiliatedProgramPlans () {
        return {
          initial: this.existingItem && this.existingItem.data.options.belongsToTemplate ? this.existingItem.data.options.belongsToTemplate : [],
          final: this.validatedItem && this.validatedItem.data.options.belongsToTemplate ? this.validatedItem.data.options.belongsToTemplate : []
        }
      },
      programPlansToRemoveFrom () {
        return (
          this.affiliatedProgramPlans.initial
            .filter(planId => !this.affiliatedProgramPlans.final.includes(planId))
        )
      },
      programPlansToAddTo () {
        return (
          this.affiliatedProgramPlans.final
            .filter(planId => !this.affiliatedProgramPlans.initial.includes(planId))
        )
      }
    },
    methods: {
      createUpdateProgramPlanPromise (programPlan) {
        return () => {
          return new Promise(
            (resolve, reject) => {
              let requestUrl = process.env.VUE_APP_PROGRAM_URL + '/programPlanTemplate'

              this.$axios.put(
                requestUrl,
                programPlan,
                this.requestConfig
              ).then(
                ({ data }) => {
                  resolve()
                },
                ({ response }) => {
                  reject(new APIError('Error updating one program plan', response))
                }
              )
            }
          )
        }
      },
      async updateProgramPlans (newItemId = null) {
        let currentItemId = this.itemId || newItemId

        let programPlans = await getProgramPlans()

        let programPlansToRemoveFrom = (
          this.programPlansToRemoveFrom
            .map(
              programPlanId => {
                let programPlan = programPlans.find(programPlan => programPlan.id === programPlanId)

                let { data, ...fields } = programPlan
                let { childPlans, ...dataFields } = data
                let updatedItemIds = childPlans.filter(itemId => itemId !== currentItemId)

                let updatedProgramPlan = new ProgramPlan({ ...fields, data: { ...dataFields, childPlans: updatedItemIds } })

                return updatedProgramPlan
              }
            )
        )

        let programPlansToAddTo = (
          this.programPlansToAddTo
            .map(
              programPlanId => {
                let programPlan = programPlans.find(programPlan => programPlan.id === programPlanId)

                let { data, ...fields } = programPlan
                let { childPlans, ...dataFields } = data
                let updatedItemIds = [ ...childPlans, currentItemId ]

                let updatedProgramPlan = new ProgramPlan({ ...fields, data: { ...dataFields, childPlans: updatedItemIds } })

                return updatedProgramPlan
              }
            )
        )

        let programPlansToBeUpdated = [ ...programPlansToAddTo, ...programPlansToRemoveFrom ]
        let updateProgramPlanPromises = programPlansToBeUpdated.map(this.createUpdateProgramPlanPromise)

        return Promise.allSettled(updateProgramPlanPromises.map(updateProgramPlanPromise => updateProgramPlanPromise()))
      }
    },
    render () {
      return this.$scopedSlots.default(
        {
          updateProgramPlans: this.updateProgramPlans
        }
      )
      // return this.$slots.default({})
    }
  }
)

export const ProgramPlansGetter = Vue.component(
  'ProgramPlansGetter',
  {
    props: {
      itemType: {
        type: String,
        required: true
      },
      programPlansSetter: {
        type: Function,
        required: true
      }
    },
    async created () { await this.getProgramPlansByItemType() },
    methods: {
      async getProgramPlansByItemType () {
        const allProgramPlans = await getProgramPlans(this.$axios, this.requestConfig)
        const programPlansByItemType = allProgramPlans.filter(programPlan => programPlan.planType === this.itemType)

        this.programPlansSetter(programPlansByItemType)
      }
    },
    render () {
      return this.$scopedSlots.default(
        {}
      )
      // return this.$slots.default({})
    }
  }
)
